import {NavigableDirective} from "./directives/navigableDirective";
import {NavigatableModule} from "./navigatableModuleConfiguration";

NavigatableModule
    .createNewModule()
    .directive('ngNavigableWrapper', NavigableDirective);
